import React, {useState} from 'react';
import PropTypes from 'prop-types';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import {loginUiTexts} from 'data/ui-texts';
import {getText} from 'helpers/language-helper';
import Button from 'components/button/button';
import './login-open-id-facilitator.scss';

const LoginOpenIdFacilitator = ({languageId, authErrMsg, companyData}) => {
	/* Loading */
	const [isLoading, setIsLoading] = useState(false);

	/* Error message */
	const [errorMessage, setErrorMessage] = useState(null);
	let displayedErrorMessage = errorMessage;
	if (authErrMsg) displayedErrorMessage = authErrMsg;

	/* Login with OpenId */
	const handleLogin = () => {
		if (isLoading) return;

		setIsLoading(true);
		setErrorMessage(null);
		if (
			companyData && 
			companyData.loginConfig && 
			companyData.loginConfig.tenantId && 
			companyData.loginConfig.provider
		) {
			const auth = firebase.auth();
			auth.tenantId = companyData.loginConfig.tenantId;
			const provider = new firebase.auth.OAuthProvider(companyData.loginConfig.provider);
			provider.setCustomParameters({tenant: companyData.loginConfig.tentantId});
			auth.signInWithPopup(provider).then(() => {
				setIsLoading(false);
			}).catch((error) => {
				console.error(error);
				setErrorMessage(error.code);
				setIsLoading(false);
			});
		} else {
			console.error('missing company data');
			setIsLoading(false);
		}		
	};

	if (isLoading) {
		return (
			<div className="LoginOpenIdFacilitator">
				<div className="LoginOpenIdFacilitator-loadingWrapper" />
			</div>
		);
	}

	return (
		<React.Fragment>
			<div className="LoginOpenIdFacilitator">
				<div className="LoginOpenIdFacilitator-form">
					{companyData && companyData.loginConfig && <div className="LoginOpenIdFacilitator-info">
						<span>{getText(companyData.loginConfig.loginText, languageId)}</span>
					</div>}
					<p className="LoginOpenIdFacilitator-errorMessage">{displayedErrorMessage}</p> 
					<Button text={getText(loginUiTexts.login, languageId)} classes={['login']} onClick={handleLogin} />
				</div>
			</div>
		</React.Fragment>
	);
};

LoginOpenIdFacilitator.propTypes = {
	languageId: PropTypes.string.isRequired,
	authErrMsg: PropTypes.string,
	companyData: PropTypes.object.isRequired
};

export default LoginOpenIdFacilitator;